import React from 'react'
import { PluginHook, useRowSelect, Hooks } from 'react-table'

import Input from '../../atoms/form/input/Input'


export const rowSelectPlugin: PluginHook<any>[] = [
  useRowSelect,
  (hooks: Hooks) => {
    hooks.visibleColumns.push((columns) => [
      {
        id: 'selection',
        Header: ({ getToggleAllRowsSelectedProps }) => {
          const checkboxProps = {
            ...getToggleAllRowsSelectedProps(),
            indeterminate: undefined
          }
          return (
            <div style={{marginTop: '20px'}}>
              <Input
                {...checkboxProps}
                className='checkbox'
                type='checkbox'
                data-test={'select-all'}
              />
            </div>
          )
        },
        Cell: ({ row }) => {
          const checkboxProps = {
            ...row.getToggleRowSelectedProps(),
            indeterminate: undefined
          }
          return (
            <div>
              <Input
                {...checkboxProps}
                className='checkbox'
                type='checkbox'
                data-test={`select-${(row.original as any).id}`}
              />
            </div>
          )
        }
      },
      ...columns
    ])
  }
]
